module.exports = __webpack_public_path__ + "static/media/raos.999e436c.jpg";